import { codeSchema } from "./code";
import { separatorSchema } from "./separator";
import { imageSchema } from "./image";
import { imageFilesSchema } from "./image-files";
import { listSchema } from "./list";
import { paragraphSchema } from "./paragraph";
import { quoteSchema } from "./quote";
import { tableSchema } from "./table";
import { videoSchema } from "./video";
import { videoFileSchema } from "./video-files";

const blocksSchema = [
  paragraphSchema,
  imageSchema,
  listSchema,
  quoteSchema,
  codeSchema,
  separatorSchema,
  tableSchema,
  videoSchema,
];

const filesSchema = [imageFilesSchema, videoFileSchema];

export { blocksSchema, filesSchema };
